<template>
  <div class="content">
    <div class="left-sidebar" id="left-sidebar">
      <el-menu default-active="2" class="el-menu-vertical-demo">
        <el-submenu v-for="item in items" :index="item.index" :key="item.index">
          <template slot="title">
            <i class="el-icon-menu"></i>{{ item.name }}</template>
          <el-menu-item v-for="option in item.options" :index="option.index" :key="option.index">
            <router-link :to="option.link">{{ option.name }}</router-link>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <keep-alive :max="1">
      <router-view v-if="$route.meta.keepAlive" class="right-iframe" id="right-iframe"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="right-iframe" id="right-iframe"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [{
        name: "用户管理",
        index: "2",
        options: [
          { index: "2-1", link: "/user/all", name: "所有用户" },
          { index: "2-2", link: "/user/verification", name: "用户验证信息" },
          { index: "2-3", link: "/userM/campusIdManage", name: "找回学号" },
          { index: "2-4", link: "/userM/reportManage", name: "举报审核" },
          { index: "2-5", link: "/userM/suspicious", name: "可疑用户" },
          { index: "2-7", link: "/userM/specific", name: "个性化组件" },
        ],
      }, {
        name: "设备管理",
        index: "3",
        options: [
          { index: "3-1", link: "/device/deviceComplain", name: "设备绑定申请", },
        ],
      }],
    };
  },
  mounted() {
    // let ip = localStorage.getItem("ip");
    // console.log(ip);

    // const oScript = document.createElement("script");
    // oScript.type = "text/javascript";
    // oScript.src = "https://api.ipify.org/?format=json";
    // document.body.appendChild(oScript);
    // console.log(ip, "/////////");

    let authWriteList = JSON.parse(localStorage.getItem("user"));
    if (authWriteList && authWriteList.authWriteList) {
      this.items.push({
        name: "白名单管理",
        index: "4",
        options: [
          { index: "4-1", link: "/whitelist/clearWhiteList", name: "清场白名单", },
        ],
      });
    }
    if (!this.$util.isComplexVersion) {
      this.items = [
        {
          name: "用户管理",
          index: "2",
          options: [
            { index: "2-1", link: "/userM/allUser", name: "所有用户" },
            { index: "2-2", link: "/userM/userTest", name: "用户验证信息" },
            { index: "2-3", link: "/userM/campusIdManage", name: "找回学号" },
          ],
        },
      ];
    }
    // if (ip == "123.157.157.194" && this.$util.isComplexVersion) {
    this.items[0].options.push({
      index: "2-6",
      link: "/userM/dataRepair",
      name: "数据修复",
    });
    // }
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?42fd8b9a